import React from 'react';

import MPubList from './mPubList';
import MPubSearch from './mPubSearch';
import AjaxFunctions from '../ajaxFunctions'
export default class MPubSearchList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchReturns: undefined,
        };
    }

    async search(searchString, advSearch) {
        let searchReturns = await this.props.lastFilterFunction();
        this.setState({ searchReturns });
        /*
        let filterData = {
            searchString,
            cardTypes: [],
            topics: [],
            cardLimit: 20
        };

        advSearch.forEach(filter => {
            if (filter.name == 'Evidence') {
                filterData.cardTypes.push(SharedConstants.CardType.Evidence);
            } else if (filter.name == 'Conjecture') {
                filterData.cardTypes.push(SharedConstants.CardType.Reasoning);
            } else {
                filterData.topics.push(filter.idTopic);
            }
        });

        const hasFilterData = searchString
            || filterData.cardTypes.length > 0
            || filterData.topics.length > 0;
        if (hasFilterData) {
            AjaxFunctions.getFilteredCardData(filterData).then(searchReturns => {
                this.setState({ searchReturns });
            });
        } else {
            this.setState({ searchReturns: undefined });
        }

         */
    }

    render() {
        const { searchReturns } = this.state;
        return (
            <div className='searchlist-container'>
                <MPubSearch search={(...args) => this.search(...args)}/>
                <MPubList
                    cards={searchReturns}
                />
            </div>
        );
    }
}
